import { BellRing } from "lucide-react";

export const fmtTime = (iso) => {
  const d = new Date(iso);
  const time = d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  if (new Date().toDateString() === d.toDateString()) return time;
  return `${d.toLocaleDateString([], { month: "short", day: "numeric" })} · ${time}`;
};

function NoticeCard({ m }) {
  return (
    <div className="mx-auto max-w-[85%] rounded-xl border border-amber-200 bg-amber-50 p-3.5" data-testid={`chat-message-${m.id}`}>
      <div className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-amber-700 mb-1"><BellRing className="h-3 w-3" /> Notice · {fmtTime(m.created_at)}</div>
      <div className="text-sm font-semibold text-slate-900">{m.subject}</div>
      <p className="text-xs text-slate-600 mt-1 whitespace-pre-wrap line-clamp-6">{m.body}</p>
    </div>
  );
}

export function ChatMessage({ m, myRole }) {
  if (m.kind === "notice") return <NoticeCard m={m} />;
  const mine = m.sender_role === myRole;
  const bubble = mine ? "bg-primary text-primary-foreground rounded-br-md" : "bg-white border border-slate-200 text-slate-800 rounded-bl-md";
  return (
    <div className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid={`chat-message-${m.id}`}>
      <div className={`max-w-[75%] rounded-2xl px-4 py-2.5 text-sm whitespace-pre-wrap shadow-sm ${bubble}`}>
        {m.body}
        <div className={`text-[10px] mt-1 ${mine ? "text-white/70" : "text-slate-400"}`}>{fmtTime(m.created_at)}</div>
      </div>
    </div>
  );
}
